import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = location.hash.match(/session_id=([^&]+)/)?.[1];
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }
        axios
            .post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
            .then(({ data }) => {
                setUser(data);
                navigate("/account", { replace: true, state: { user: data } });
            })
            .catch(() => navigate("/", { replace: true }));
    }, [location.hash, navigate, setUser]);

    return (
        <main className="flex min-h-screen items-center justify-center bg-white">
            <p className="text-sm font-extralight tracking-wide text-slate-400">Signing you in…</p>
        </main>
    );
}
